import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import PracticeCard from "../practice-card/index.vue";
import MultiSelectFilterStatus from "../multi-select-filter-status/index.vue";
import MultiSelectFilterYears from "../multi-select-filter-years/index.vue";
import { ComplianceForm, PageContent } from "@/shared/modules/typescript-trustapi-client/models";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import HelpScreen from "../help-screen/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import UpdateEEModal from "./update-ee-modal/index.vue";

@Options({
  components: {
    LoadingSpinner,
    PracticeCard,
    MultiSelectFilterYears,
    MultiSelectFilterStatus,
    HelpScreen,
    UpdateEEModal,
  },
  mixins: [FormatDateTimeMixin],
})
export default class EEDashboard extends Vue {

  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private practices: ComplianceForm[] = [];
  private complianceForm: ComplianceForm[] = [];

  private yearsList: any = [
    {
      "id": -1,
      "name": "All",
      "description": "All",
      "inactive": false
    }
  ];

  private selectedYears = [];

  private selectYears(val: any) {
    this.selectedYears = val;
  }

  private statusList = [
    {
      "id": -1,
      "name": "All",
      "description": "All",
      "inactive": false
    }];

  private selectedStatus = [];

  private selectStatus(val: any) {
    this.selectedStatus = val;
  }

  private isLoadingData = false;
  private dashboardType = 1;  // Dashboard type of External Examiner

  private helpContent: PageContent = {};
  private showHelpScreen = false;

  mounted(): void {
    this.eventCtrl.on('loadCardData', this.loadCardData);
    this.loadFilter();
    this.loadCardData();
  }

  beforeUnmount(): void {
    this.eventCtrl.off('loadCardData', this.loadCardData);
  }

  private async loadFilter() {
    try {
      const resp: any[] = await Promise.all([
        await this.apiService.ComplianceFormApi?.apiV2ComplianceFormGetComplianceYearsGet(),
        await this.apiService.ComplianceFormApi?.apiV2ComplianceFormGetProgressesGet(),
      ]);

      this.yearsList = [{
        "id": -1,
        "name": "All",
        "description": "All",
        "inactive": false
      }, ...resp[0].data.data];

      this.statusList = [{
        "id": -1,
        "name": "All",
        "description": "All",
        "inactive": false
      }, ...resp[1].data.data];

      this.helpContent = this.$getPopover('Help', 18);
      this.eventCtrl.emit('updateHelpContent', this.helpContent);

    }
    catch (err) {
      this.ai.trackException('Error, Unable to load filter data: ' + err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load filter data');
    }

  }

  private async loadCardData() {
    this.isLoadingData = true;
    await this.apiService.ComplianceFormApi?.apiV2ComplianceFormGetComplianceFormsGet()
      .then((resp: any) => {
        this.complianceForm = resp.data.data;
        this.onFilterChange();
        this.isLoadingData = false;
      })
      .catch((err: any) => {
        this.isLoadingData = false;
        this.ai.trackException('Error, Unable to load practice cards: ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load practice cards');
      });
  }

  @Watch('selectedYears')
  private async onYearChange() {
    this.onFilterChange();
  }

  @Watch('selectedStatus')
  private async onStatusChange() {
    this.onFilterChange();
  }

  private async onFilterChange() {
    const selectedYearsArray = this.selectedYears.map((item: any) => item.name);
    const selectedStatusArray = this.selectedStatus.map((item: any) => item.name);
    // filter only this.compliance Form that match selectedYearsArray and selectedStatusArray
    this.practices = this.complianceForm.filter((item: any) => {
      return selectedYearsArray.includes(item.complianceYear.name) && selectedStatusArray.includes(item.progress.name);
    });
  }

  private showUpdateEEmodal = false;

  private updateEE() {
    this.showUpdateEEmodal = true;

  }

}